(() => {
const measurements = [["S",120,61,59,70],["M",124,63,60,72],["L",128,65,61,74],["XL",132,67,62,76],["2XL",136,69,63,78],["3XL",140,71,64,80]];
function initialize() {
 const labels = document.getElementById('chiefzip-size-labels');
 if (!labels) return;
 const strings = JSON.parse(labels.textContent);
 document.querySelectorAll('.sizing-chart-table').forEach(table => {
  const modal = table.closest('.sizing-chart__modal');
  if (!modal || !modal.querySelector('.sizing-chart__title')?.textContent.includes('ChiefZip') || table.dataset.chiefzipUnits) return;
  const rows = Array.from(table.querySelectorAll('tbody tr'));
  if (rows.length !== measurements.length || rows.some((row,i)=>row.cells.length !== 5 || row.cells[0].textContent.trim() !== measurements[i][0])) return;
  table.dataset.chiefzipUnits = 'in';
  const controls = document.createElement('div');
  controls.style.cssText = 'display:flex;justify-content:flex-end;align-items:center;gap:12px;margin:16px 0;font-weight:600';
  const label = document.createElement('span');
  label.textContent = strings.units;
  controls.append(label);
  const group = document.createElement('div');
  group.setAttribute('role','group');
  group.setAttribute('aria-label',strings.units);
  group.style.cssText = 'display:inline-flex;border:1px solid #000;border-radius:999px;padding:3px;gap:2px;background:#fff';
  const buttons = [];
  function update(unit) {
   rows.forEach((row,i)=>measurements[i].slice(1).forEach((cm,j)=>{
    row.cells[j+1].textContent = unit==='in' ? (cm/2.54).toFixed(2)+' in' : cm+' cm';
   }));
   buttons.forEach(button=>{
    const selected=button.dataset.unit===unit;
    button.setAttribute('aria-pressed',String(selected));
    button.style.backgroundColor=selected?'#000':'#fff';
    button.style.color=selected?'#fff':'#000';
   });
   table.dataset.chiefzipUnits=unit;
  }
  [['in','IN',strings.inches],['cm','CM',strings.centimeters]].forEach(([unit,text,name])=>{
   const button=document.createElement('button');
   button.type='button';
   button.dataset.unit=unit;
   button.textContent=text;
   button.setAttribute('aria-label',name);
   button.style.cssText='font:inherit;font-size:14px;line-height:1;letter-spacing:.04em;min-width:54px;min-height:40px;padding:10px 16px;border:0;border-radius:999px;cursor:pointer';
   button.addEventListener('click',()=>update(unit));
   buttons.push(button);
   group.append(button);
  });
  controls.append(group);
  table.before(controls);
  update('in');
 });
}
initialize();
document.addEventListener('shopify:section:load',initialize);
})();